// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordStatus_container__1Y7qX","status":"RecordStatus_status__2jxZ-","statusOnline":"RecordStatus_statusOnline__2loQ0"};